import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { Text, Box, Grid, GridItem, SimpleGrid, Tabs, TabList, TabPanels, Tab, TabPanel, Table, HStack, VStack } from '@chakra-ui/react';

import DetailOrderTable from "./DetailOrderTable";
import DetailItemTable from "./DetailItemTable";
import DetailLotTable from "./DetailLotTable";



export default class SummaryBatchDisplay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRow: null,
            rowKeys: '',
            selectedItemRow: null
        };

        this.itemRowChange = this.itemRowChange.bind(this);
    }



    itemRowChange(newItemRow) {
        this.setState({ selectedItemRow: newItemRow });
    }


    render() {

        return (

            <VStack w="100%">
                <DetailOrderTable
                    selectedRow={this.props.selectedRow}
                />

                <HStack w="100%" alignItems={"flex-start"}>
                            
                        <DetailItemTable
                            selectedRow={this.props.selectedRow}
                            selectedItemRowChange={this.itemRowChange}
                        />

                        <DetailLotTable
                            selectedItemRow={this.state.selectedItemRow}
                        />

                </HStack >
            </VStack>
        );
    }
}
